import React, { useState } from "react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Fonction pour basculer l'état du menu
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="bg-[#03224C]/80 fixed top-0 left-0 w-full z-10 p-4">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo and Title */}
        <div className="flex items-center space-x-3">
          {/* Logo */}
          <img
            src="/images/logo2.png"
            alt="Logo"
            className="w-10 h-10 rounded-full animate-spin-slow"
          />
          {/* Portfolio Text */}
          <h1 className="text-2xl font-semibold text-white">
            <span className="text-white">Portfo</span>
            <span className="text-red-600">lio</span>
          </h1>
        </div>

        {/* Hamburger Button */}
        <div className="md:hidden">
          <button
            onClick={toggleMenu}
            className="text-white focus:outline-none"
          >
            {/* Icone pour menu hamburger ou croix */}
            {isOpen ? (
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </button>
        </div>

        {/* Navigation Links */}
        <ul
          className={`md:flex md:space-x-8 text-white font-semibold md:static absolute bg-[#03224C] md:bg-transparent top-16 left-0 w-full md:w-auto md:flex md:items-center transition-all duration-300 ease-in-out transform ${
            isOpen ? "block" : "hidden"
          }`}
        >
          <li className="p-4 md:p-0">
            <a
              href="#accueil"
              className="hover:text-blue-500 relative group transition duration-300 ease-in-out"
            >
              Accueil
              <span className="block h-0.5 bg-gray-100 scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-300 ease-in-out"></span>
            </a>
          </li>
          <li className="p-4 md:p-0">
            <a
              href="#apropos"
              className="hover:text-blue-500 relative group transition duration-300 ease-in-out"
            >
              À propos
              <span className="block h-0.5 bg-gray-100 scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-300 ease-in-out"></span>
            </a>
          </li>
          <li className="p-4 md:p-0">
            <a
              href="#competences"
              className="hover:text-blue-500 relative group transition duration-300 ease-in-out"
            >
              Compétences
              <span className="block h-0.5 bg-gray-100 scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-300 ease-in-out"></span>
            </a>
          </li>
          <li className="p-4 md:p-0">
            <a
              href="#realisations"
              className="hover:text-blue-500 relative group transition duration-300 ease-in-out"
            >
              Mes réalisations
              <span className="block h-0.5 bg-gray-100 scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-300 ease-in-out"></span>
            </a>
          </li>
          <li className="p-4 md:p-0">
            <a
              href="#contact"
              className="hover:text-blue-500 relative group transition duration-300 ease-in-out"
            >
              Contact
              <span className="block h-0.5 bg-gray-100 scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-300 ease-in-out"></span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
